import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const GroupUsersWrapper = styled(Flexbox)`
  margin-right: 26px;
  width: 100%;

  > div {
    width: 100%;
  }
  
  [role="row"]:first-child > [role="columnheader"] {
    :nth-child(4) {
      text-align: center;
    }

    [role="presentation"] {
      margin: 0;
      width: 0;
      height: 0;
    }
  }

  [role="row"] > div {
    flex: 1 1 auto !important;
    width: 100% !important;
  }
`;
